import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { formatApiError } from "@/contexts/AuthContext";

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!token) {
      setStatus("missing");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="mx-auto max-w-md px-4 py-16 text-center">
      <h1 className="font-display text-2xl font-bold text-white">Email verification</h1>
      {status === "loading" && <p className="mt-4 text-white/60">Verifying…</p>}
      {status === "ok" && <p className="mt-4 text-emerald-300">Your email is verified. You can sign in now.</p>}
      {status === "error" && <p className="mt-4 text-rose-300">Invalid or expired link.</p>}
      {status === "missing" && <p className="mt-4 text-rose-300">No token provided.</p>}
      <Link to="/login" className="inline-block mt-8 text-[#D4AF37] hover:underline">Go to sign in</Link>
    </div>
  );
};

export default VerifyEmail;
